import { Outlet, useLocation } from "react-router-dom";
import { LandingNavbar } from "./LandingNavBar";
import { Toaster } from "@/components/ui/sonner";
import CalendlyBadge from "@/components/calendly-badge";

export default function LandingLayout() {
  const location = useLocation();
  const showCalendly = location.pathname === "/";
  return (
    <>
    {/* {showCalendly && <CalendlyBadge />} */}
      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{
          unstyled: false,
          classNames: {
            error: "bg-red-400",
            success: "text-green-400",
            warning: "text-yellow-400",
            info: "bg-blue-400",
          },
        }}
      />
      <LandingNavbar />
      <Outlet />
    </>
  );
}
